import {
  FETCH_APPOINTMENT_TYPES,
  FETCH_SYMPTOM_TYPES,
  UPLOAD_LETTERS,
  APPOINTMENT_LOADER,
  CREATE_APPOINTMENT_SUCCESS,
  CREATE_APPOINTMENT_ERROR,
  ERROR_RESET,
  FETCH_APPOINTMENT_ARTICLES,
  UPLOAD_MEDICAL_RECORDS,
  CREATE_MEDICAL_RECORDS_ERROR,
  CREATE_MEDICAL_RECORDS_SUCCESS,
  FORM_RESET,
  GET_FILE_URL,
  FETCH_APPOINTMENT_ORDERS,
  FETCH_MEDICAL_DOCUMENTS,
  GET_FILE_URL_ERROR,
  INITIATE_APPOINTMENT_REPORTS_FETCH,
  INITIATE_GENERATE_REPORT,
  GENERATE_ENCOUNTER_REPORT,
  FETCH_APPOINTMENT_FAX_LOGS,
  PUT_MRR_FILES,
  DOWNLOAD_ARCHIEVE,
  DOWNLOAD_S3_ACCESS_URL,
} from './Constants';
import { chrApi, phrApi, uploadDocuments } from '../../api/api';

export function fetchAppointmentTypes(providerId, practiceId) {
  const list = phrApi('get', 'appointmenttype', null, {
    providerId,
    practiceId,
  });
  return (dispatch) => {
    list
      .then((response) => {
        dispatch({ type: FETCH_APPOINTMENT_TYPES, payload: response });
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function loading() {
  return { type: APPOINTMENT_LOADER };
}

export function formReset() {
  return { type: FORM_RESET };
}

export function createAppointmentSuccess(data) {
  return { type: CREATE_APPOINTMENT_SUCCESS, payload: data };
}

export function createAppointmentError(data) {
  return { type: CREATE_APPOINTMENT_ERROR, payload: data };
}

export function uploadLetters(files) {
  const formData = new FormData();
  formData.append('path', 'Letters');
  Array.from(files).map((file) => formData.append('file', file));
  const imageArr = uploadDocuments('file_upload', formData);
  return (dispatch) => {
    dispatch(loading());
    imageArr.then((response) => dispatch({ type: UPLOAD_LETTERS, payload: response })).catch((error) => console.log(error.response));
  };
}

export function createAppointment(obj) {
  const appointment = chrApi('post', 'appointment', obj);
  return (dispatch) => {
    dispatch(loading());
    appointment.then((response) => dispatch(createAppointmentSuccess(response))).catch((error) => dispatch(createAppointmentError(error.response)));
  };
}

export function uploadMedicalRecords(files) {
  const formData = new FormData();
  formData.append('path', 'MedicalRecords');
  Array.from(files).map((file) => formData.append('file', file));
  const recordArr = uploadDocuments('file_upload', formData);
  return (dispatch) => {
    dispatch(loading());
    return recordArr.then((response) => dispatch({ type: UPLOAD_MEDICAL_RECORDS, payload: response })).catch((error) => console.log(error.response));
  };
}

export function createMedicalRecordsSuccess(data) {
  return { type: CREATE_MEDICAL_RECORDS_SUCCESS, payload: data };
}

export function createMedicalRecordsError(data) {
  return { type: CREATE_MEDICAL_RECORDS_ERROR, payload: data };
}

export function createMedicalRecords(obj, patientId) {
  const medicalRecords = chrApi('post', `medical_document/patient/${patientId}`, obj);
  return (dispatch) => {
    dispatch(loading());
    return medicalRecords.then((response) => dispatch(createMedicalRecordsSuccess(response))).catch((error) => dispatch(createMedicalRecordsError(error.response)));
  };
}

export function postMedicalRecords(files, obj, patientId) {
  return (dispatch, getState) =>
    dispatch(uploadMedicalRecords(files)).then(() => {
      const { medicalRecords } = getState().Appointment;
      return dispatch(createMedicalRecords({ ...obj, urls: medicalRecords }, patientId));
    });
}

export function fetchAppointmentArticles(appointmentId) {
  const articles = chrApi('get', `article/appointment/${appointmentId}`, null);
  return (dispatch) => {
    dispatch(loading());
    articles.then((response) => dispatch({ type: FETCH_APPOINTMENT_ARTICLES, payload: response })).catch((error) => console.log(error.response));
  };
}

export function errorReset() {
  return { type: ERROR_RESET };
}

export function getFileAccessUrl(key) {
  const url = phrApi('post', 's3_access_url', { urls: [key] });
  return (dispatch) => {
    dispatch(loading());
    return url.then((response) => dispatch({ type: GET_FILE_URL, payload: response })).catch((error) => dispatch({ type: GET_FILE_URL_ERROR, payload: error }));
  };
}

export function getFormsPdf(obj) {
  return {
    type: INITIATE_GENERATE_REPORT,
    payload: { data: obj },
  };
}

export function fetchAppointmentOrders(appointmentId) {
  const orders = chrApi('get', `provider_order/appointment/${appointmentId}`, null);
  return (dispatch) => {
    dispatch(loading());
    orders
      .then((response) => dispatch({ type: FETCH_APPOINTMENT_ORDERS, payload: response }))
      .then((error) => {
        console.log(error);
      });
  };
}

export function fetchMedicalDocuments(patientId) {
  const documents = chrApi('get', `medical_document/patient/${patientId}`, null);
  return (dispatch) => {
    dispatch(loading());
    documents
      .then((response) => dispatch({ type: FETCH_MEDICAL_DOCUMENTS, payload: response }))
      .catch((error) => {
        throw new Error(error);
      });
  };
}

export function fetchAppointmentReports(appointmentId) {
  return {
    type: INITIATE_APPOINTMENT_REPORTS_FETCH,
    payload: { appointmentId },
  };
}

export function generateEncounterReport(appointmentId) {
  return { type: GENERATE_ENCOUNTER_REPORT, payload: { appointmentId } };
}

export function fetchAppointmentFaxLogs(appointmentId) {
  return { type: FETCH_APPOINTMENT_FAX_LOGS, payload: { appointmentId } };
}

export function putMRRFiles(files, encounterNoteId) {
  return { type: PUT_MRR_FILES, payload: { files, encounterNoteId } };
}

export function downloadArchive(payload) {
  return { type: DOWNLOAD_ARCHIEVE, payload };
}

export function downloadS3AccessUrl(key) {
  return { type: DOWNLOAD_S3_ACCESS_URL, payload: key };
}
